import React from 'react';
import { Navigate } from 'react-router-dom';
import useAuth from './hooks/useAuth';

const ProtectedRoute = ({ children }: { children: React.ReactElement }) => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <div>Loading...</div>; // Or a proper spinner component
  }

  return isAuthenticated ? children : <Navigate to="/" />;
};

export default ProtectedRoute; 